import { useMsal } from "@azure/msal-react";
import React from "react";
import { FC } from "react";
import { Button, Container, Navbar, Table } from "react-bootstrap";

export const ProfilePage: FC = () => {

    const { accounts } = useMsal()

    const clearCache = () => {
        localStorage.clear();
        window.location.reload();
    }

    return (
        <>
            <Navbar sticky="top" key={'nav-bar'} expand={false} className="bg-body-secondary mb-3">
                <Container fluid>
                    <h2 className="mb-0">Profile</h2>
                </Container>
            </Navbar>

            <Container>
                <Table>
                    <tbody className="text-start">
                        <tr>
                            <td>Username</td>
                            <td>{accounts[0].name}</td>
                        </tr>
                        <tr>
                            <td>Email</td>
                            <td>{accounts[0].username}</td>
                        </tr>
                        <tr>
                            <td>Account ID</td>
                            <td>{accounts[0].idTokenClaims?.oid}</td>
                        </tr>
                    </tbody>
                </Table>
                <Button variant="danger" onClick={clearCache}>Clear Cache</Button>
            </Container>
        </>
    )
}